var esgGraphManager = (function(){
    function init(){
        if(!$("section.esg-graph-component").length) return;

        topPath = ".esg-graph-component svg g#top-left, .esg-graph-component svg g#top-right";
        topPathDecorator = ".esg-graph-component .decorator-container-top";
        
        centerPath = ".esg-graph-component svg g#center-left, .esg-graph-component svg g#center-right";
        centerPathDecorator = ".esg-graph-component .decorator-container-center";
        
        bottomPath = ".esg-graph-component svg g#bottom-left, .esg-graph-component svg g#bottom-right";
        bottomPathDecorator = ".esg-graph-component .decorator-container-bottom";

        var owl = $(".new-slider-small-component .owl-carousel");

        owl.on("changed.owl.carousel", function(e){
            toActivateIndex = e.item.index;
            
            switch (toActivateIndex) {
                case 0:
                    $(topPathDecorator).click();
                    break;
                case 1:
                    $(centerPathDecorator).click(); 
                    break;
                case 2:
                    $(bottomPathDecorator).click(); 
                    break;
            
                default:
                    break;
            }
            $("section.esg-graph-component .esg-graph-icons-description-place").eq(toActivateIndex).removeClass("inactive"); 
            $("section.esg-graph-component button").eq(toActivateIndex).removeClass("inactive");
        })

        $(topPathDecorator).click(function(){
            deactivateAll();
            $(topPath).removeClass("inactive");
            $(topPathDecorator).removeClass("inactive");
            updateCarousel(owl,0);
        })

        $(centerPathDecorator).click(function(){
            deactivateAll();
            $(centerPath).removeClass("inactive");
            $(centerPathDecorator).removeClass("inactive");
            $(centerPathDecorator).css("height", "225px");
            updateCarousel(owl,1);
        })

        $(bottomPathDecorator).click(function(){
            deactivateAll();
            $(bottomPath).removeClass("inactive");
            $(bottomPathDecorator).removeClass("inactive");
            updateCarousel(owl,2);
        })


        //CASO MOBILE:
        $("section.esg-graph-component button").click(function(){
            index = $(this).index();
            deactivateAll();
            switch (index) {
                case 1:
                    $(topPath).removeClass("inactive");
                    $(topPathDecorator).removeClass("inactive");
                    break;
                case 2:
                    $(centerPath).removeClass("inactive");
                    $(centerPathDecorator).removeClass("inactive");
                    $(centerPathDecorator).css("height", "225px");
                    break;
                case 3:
                    $(bottomPath).removeClass("inactive");
                    $(bottomPathDecorator).removeClass("inactive");
                    break;
            
                default:
                    break;
            }
            updateCarousel(owl,index-1);
            $("section.esg-graph-component .esg-graph-icons-description-place").eq(index-1).removeClass("inactive");
            $(this).removeClass("inactive");
            
        })

        //FINE CASO MOBILE
        if($(window).width() < 991 ){
            $(topPath).click(function(){
                deactivateAll();
                $(topPath).removeClass("inactive");
                $(topPathDecorator).removeClass("inactive");
                $("section.esg-graph-component .esg-graph-icons-description-place").eq(0).removeClass("inactive");
                $("section.esg-graph-component button").eq(0).removeClass("inactive");
                updateCarousel(owl,0);
            })
            $(centerPath).click(function(){
                deactivateAll();
                $(centerPath).removeClass("inactive");
                $(centerPathDecorator).removeClass("inactive");
                $(centerPathDecorator).css("height", "225px");
                $("section.esg-graph-component .esg-graph-icons-description-place").eq(1).removeClass("inactive");
                $("section.esg-graph-component button").eq(1).removeClass("inactive");
                updateCarousel(owl,1);
            })

            $(bottomPath).click(function(){
                deactivateAll();
                $(bottomPath).removeClass("inactive");
                $(bottomPathDecorator).removeClass("inactive");
                $("section.esg-graph-component .esg-graph-icons-description-place").eq(2).removeClass("inactive");
                $("section.esg-graph-component button").eq(2).removeClass("inactive");
                updateCarousel(owl,2);
            })
        } 
        
        
    }

    function deactivateAll(){
        $(".esg-graph-component svg g").addClass("inactive");
        $(".single-decorator").addClass("inactive");
        $(".single-decorator").css("height", "155px");
        $("section.esg-graph-component button").addClass("inactive");
        $(".esg-graph-component .esg-graph-icons-description-place").addClass("inactive");
    }

    function updateCarousel(owl, index)
    {
        owl.trigger("to.owl.carousel", index);
    }

    return {
        init:init
    }
})(jQuery);